import { jsx } from "panel";
import { TooltipEl } from "common/components/tooltip";
import { AutoResizingInputEl } from "common/components/autoresizing-input";
import { DropMenuEl } from "common/components/drop-menu";
import { ItemsMenuEl } from "common/components/items-menu";
import { TagEl } from "common/components/tag";
import { TagSize, TagTheme } from "common/components/tag/types";
import { Placement } from "common/components/tooltip/types";
const TextInput = (_ref) => {
  let {
    cmp
  } = _ref;
  const {
    inputValue,
    recipientInputEl
  } = cmp.state;
  return /* @__PURE__ */ jsx("div", { sel: ".text-input-container", "data-sentry-component": "TextInput", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(AutoResizingInputEl, { sel: ".text-input", attrs: {
    elref: "emailRecipientsInput",
    focus: true,
    "initial-width": 4,
    "input-style-overrides": {
      "font-size": "16px",
      "max-width": "440px"
    },
    "style-override": "input {background: none;}"
  }, hook: {
    insert: cmp.helpers.handleRecipientInputInsert
  }, on: {
    click: (ev) => ev.stopPropagation(),
    input: (_ref2) => {
      let {
        target
      } = _ref2;
      return cmp.update({
        inputValue: target.value
      });
    },
    focusout: cmp.helpers.handleRecipientInputFocusOut,
    keydown: cmp.helpers.handleRecipientInputKeydown
  }, props: {
    value: inputValue
  }, "data-sentry-element": "AutoResizingInputEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx(DropMenuEl, { sel: ".members-dropdown", attrs: {
    open: Boolean(inputValue)
  }, "data-sentry-element": "DropMenuEl", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(ItemsMenuEl, { attrs: {
    elref: "emailRecipientsInputSearchList",
    "search-filter": inputValue
  }, props: {
    keydownProxyEl: inputValue ? recipientInputEl : null,
    sections: [cmp.helpers.getProjectMembersMenuSection()],
    sectionsFromInputFn: cmp.helpers.recipientFromInput
  }, on: {
    click: (ev) => ev.stopPropagation(),
    mousedown: (ev) => ev.preventDefault(),
    clickItem: (ev) => cmp.helpers.clickedProjectMember(ev)
  }, "data-sentry-element": "ItemsMenuEl", "data-sentry-source-file": "template.tsx" })));
};
const RecipientTag = (_ref3) => {
  let {
    cmp,
    recipient,
    idx
  } = _ref3;
  const isDuplicate = cmp.helpers.checkRecipientIfSubsequentDuplicate(recipient, idx);
  return /* @__PURE__ */ jsx("div", { sel: ".recipient", "data-sentry-component": "RecipientTag", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(TagEl, { attrs: {
    clickable: !cmp.attr("disabled"),
    icon: recipient.id ? "profile" : "",
    removable: !cmp.attr("disabled"),
    size: TagSize.Small,
    "tag-name": recipient.id ? recipient.name : recipient.email,
    theme: TagTheme.Light
  }, on: {
    click: (ev) => ev.stopPropagation(),
    select: cmp.attr("disabled") ? null : () => cmp.helpers.selectRecipientAt(idx),
    remove: cmp.attr("disabled") ? null : () => cmp.helpers.removeRecipientAt(idx)
  }, props: {
    value: recipient
  }, "data-sentry-element": "TagEl", "data-sentry-source-file": "template.tsx" }), recipient.invalidAddress ? /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Bottom
  } }, "Invalid email address") : isDuplicate ? /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Bottom
  } }, "Duplicate ", recipient.id ? "user" : "email address") : null);
};
export function template() {
  const {
    inputValue,
    textInputIdx
  } = this.state;
  return /* @__PURE__ */ jsx("div", { sel: ".container", attrs: {
    elref: "emailRecipientsEmailContainer"
  }, class: {
    disabled: this.attr("disabled"),
    borderless: this.attr("borderless"),
    "one-line-input": this.attr("one-line-input")
  }, on: {
    click: this.attr("disabled") ? null : this.helpers.handleContainerClick
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, this.attr("recipients").length === 0 && !inputValue ? (
    // use snabbdom key to prevent .empty-state DOM removal from affecting other elements
    /* @__PURE__ */ jsx("div", { sel: ".empty-state", key: "empty" }, "No recipients")
  ) : null, this.attr("recipients").map((recipient, idx) => textInputIdx === idx ? TextInput({
    cmp: this
  }) : RecipientTag({
    cmp: this,
    idx,
    recipient
  })), textInputIdx === this.attr("recipients").length ? TextInput({
    cmp: this
  }) : null);
}
